import React from 'react';
import { t } from "ttag";
import { IconButton, useConfirmation, useToast } from '@coolremote/shared';
import { DeleteIcon } from "../../logos";
import LightTooltip from "../Tooltip/LightTooltip";
import useStyles from "./Delete.style";

export default function Delete(props: any) {
  const { className, iconStyle, object: objectToDelete, type, detach, disabled = false } = props;

  const classes = useStyles();
  const confirm = useConfirmation();
  const { flashError } = useToast();

  const fullName = !objectToDelete.name ? `${objectToDelete.firstName} ${objectToDelete.lastName}` : "";
  const itemName = objectToDelete.name || objectToDelete.serial || fullName;

  const handleClickOpen = async (event: any) => {
    event.stopPropagation();
    const ok = await confirm({
      title: t`Delete ` + type,
      bodyMessage: t`Are you sure you want to delete ` + `${itemName}  ?`,
      confirmText: t`Yes`,
      cancelText: t`No`,
    });
    if (!ok) return;
    const id = objectToDelete.id || objectToDelete._id;
    const result = await detach({ id });
    if (result) flashError(result);
  };

  return (
    <LightTooltip title={t`Delete ` + type}>
      <IconButton
        disableRipple
        disabled={disabled}
        onClick={handleClickOpen}
        classes={{ root: classes.overWriteIcon }}
      >
        <DeleteIcon className={iconStyle} />
      </IconButton>
    </LightTooltip>
  );
}
